// Generated by purs version 0.14.3
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Apply = require("../Control.Apply/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Coroutine = require("../Control.Coroutine/index.js");
var Control_Monad_Free_Trans = require("../Control.Monad.Free.Trans/index.js");
var Control_Monad_Trans_Class = require("../Control.Monad.Trans.Class/index.js");
var Control_Parallel_Class = require("../Control.Parallel.Class/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Functor_Coproduct = require("../Data.Functor.Coproduct/index.js");
var Data_Identity = require("../Data.Identity/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Data_Void = require("../Data.Void/index.js");
var yieldT = function (dictMonad) {
    return function (o) {
        return Control_Monad_Free_Trans.freeT(function (v) {
            return Control_Applicative.pure(dictMonad.Applicative0())(Data_Either.Right.create(Data_Functor_Coproduct.right(new Data_Tuple.Tuple(o, Control_Applicative.pure(Control_Monad_Free_Trans.applicativeFreeT(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple))(dictMonad))(Data_Unit.unit)))));
        });
    };
};
var toProducer = function (dictMonad) {
    return Control_Monad_Free_Trans.substFreeT(dictMonad)(Control_Coroutine.functorEmit)(function (v) {
        if (v instanceof Data_Either.Left) {
            return Control_Applicative.pure(Control_Monad_Free_Trans.applicativeFreeT(Control_Coroutine.functorEmit)(dictMonad))(v.value0(Data_Maybe.Nothing.value));
        };
        if (v instanceof Data_Either.Right) {
            return Control_Monad_Free_Trans.liftFreeT(Control_Coroutine.functorEmit)(dictMonad)(new Control_Coroutine.Emit(v.value0.value0, v.value0.value1));
        };
        throw new Error("Failed pattern match at Control.Coroutine.Transducer (line 114, column 25 - line 116, column 56): " + [ v.constructor.name ]);
    });
};
var toProcess = function (dictMonad) {
    return Control_Monad_Free_Trans.substFreeT(dictMonad)(Data_Identity.functorIdentity)(function (v) {
        if (v instanceof Data_Either.Left) {
            return Control_Applicative.pure(Control_Monad_Free_Trans.applicativeFreeT(Data_Identity.functorIdentity)(dictMonad))(v.value0(Data_Maybe.Nothing.value));
        };
        if (v instanceof Data_Either.Right) {
            return Data_Void.absurd(v.value0.value0);
        };
        throw new Error("Failed pattern match at Control.Coroutine.Transducer (line 151, column 24 - line 153, column 52): " + [ v.constructor.name ]);
    });
};
var toConsumer = function (dictMonad) {
    return Control_Monad_Free_Trans.interpret(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple))(((dictMonad.Bind1()).Apply0()).Functor0())(function (v) {
        if (v instanceof Data_Either.Left) {
            return v.value0;
        };
        if (v instanceof Data_Either.Right) {
            return Data_Void.absurd(v.value0.value0);
        };
        throw new Error("Failed pattern match at Control.Coroutine.Transducer (line 122, column 24 - line 124, column 52): " + [ v.constructor.name ]);
    });
};
var fuse = function (dictMonadRec) {
    return function (dictParallel) {
        return function (t1) {
            return function (t2) {
                var proceed = function (v) {
                    return function (v1) {
                        if (v instanceof Data_Either.Right && v.value0 instanceof Data_Either.Left) {
                            return Control_Applicative.pure((dictMonadRec.Monad0()).Applicative0())(Data_Either.Right.create(Data_Functor_Coproduct.left(Data_Functor.map(Data_Functor.functorFn)(function (v2) {
                                return fuse(dictMonadRec)(dictParallel)(v2)(Control_Monad_Free_Trans.freeT(function (v3) {
                                    return Control_Applicative.pure((dictMonadRec.Monad0()).Applicative0())(v1);
                                }));
                            })(v.value0.value0))));
                        };
                        if (v1 instanceof Data_Either.Right && v1.value0 instanceof Data_Either.Right) {
                            return Control_Applicative.pure((dictMonadRec.Monad0()).Applicative0())(Data_Either.Right.create(Data_Functor_Coproduct.right(Data_Functor.map(Data_Tuple.functorTuple)(fuse(dictMonadRec)(dictParallel)(Control_Monad_Free_Trans.freeT(function (v2) {
                                return Control_Applicative.pure((dictMonadRec.Monad0()).Applicative0())(v);
                            })))(v1.value0.value0))));
                        };
                        if (v instanceof Data_Either.Right && (v.value0 instanceof Data_Either.Right && (v1 instanceof Data_Either.Right && v1.value0 instanceof Data_Either.Left))) {
                            return Control_Monad_Free_Trans.resume(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple))(dictMonadRec)(fuse(dictMonadRec)(dictParallel)(v.value0.value0.value1)(v1.value0.value0(new Data_Maybe.Just(v.value0.value0.value0))));
                        };
                        if (v instanceof Data_Either.Right && (v.value0 instanceof Data_Either.Right && v1 instanceof Data_Either.Left)) {
                            return Control_Monad_Free_Trans.resume(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple))(dictMonadRec)(fuse(dictMonadRec)(dictParallel)(v.value0.value0.value1)(Control_Applicative.pure(Control_Monad_Free_Trans.applicativeFreeT(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple))(dictMonadRec.Monad0()))(v1.value0)));
                        };
                        if (v instanceof Data_Either.Left && (v1 instanceof Data_Either.Right && v1.value0 instanceof Data_Either.Left)) {
                            return Control_Monad_Free_Trans.resume(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple))(dictMonadRec)(fuse(dictMonadRec)(dictParallel)(Control_Applicative.pure(Control_Monad_Free_Trans.applicativeFreeT(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple))(dictMonadRec.Monad0()))(v.value0))(v1.value0.value0(Data_Maybe.Nothing.value)));
                        };
                        if (v instanceof Data_Either.Left && v1 instanceof Data_Either.Left) {
                            return Control_Applicative.pure((dictMonadRec.Monad0()).Applicative0())(Data_Either.Left.create(new Data_Tuple.Tuple(v.value0, v1.value0)));
                        };
                        throw new Error("Failed pattern match at Control.Coroutine.Transducer (line 55, column 5 - line 55, column 107): " + [ v.constructor.name, v1.constructor.name ]);
                    };
                };
                var go = function (v) {
                    return Control_Bind.bind((dictMonadRec.Monad0()).Bind1())(Control_Parallel_Class.sequential(dictParallel)(Control_Apply.apply((dictParallel.Applicative1()).Apply0())(Data_Functor.map(((dictParallel.Applicative1()).Apply0()).Functor0())(Data_Tuple.Tuple.create)(Control_Parallel_Class.parallel(dictParallel)(Control_Monad_Free_Trans.resume(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple))(dictMonadRec)(v.value0))))(Control_Parallel_Class.parallel(dictParallel)(Control_Monad_Free_Trans.resume(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple))(dictMonadRec)(v.value1)))))(function (v1) {
                        return proceed(v1.value0)(v1.value1);
                    });
                };
                return Control_Monad_Free_Trans.freeT(function (v) {
                    return go(new Data_Tuple.Tuple(t1, t2));
                });
            };
        };
    };
};
var fromProducer = function (dictMonad) {
    return Control_Monad_Free_Trans.interpret(Control_Coroutine.functorEmit)(((dictMonad.Bind1()).Apply0()).Functor0())(function (v) {
        return Data_Functor_Coproduct.right(new Data_Tuple.Tuple(v.value0, v.value1));
    });
};
var fromConsumer = function (dictMonad) {
    return Control_Monad_Free_Trans.interpret(Control_Coroutine.functorAwait)(((dictMonad.Bind1()).Apply0()).Functor0())(function (v) {
        return Data_Functor_Coproduct.left(v);
    });
};
var awaitT = function (dictMonad) {
    return Control_Monad_Free_Trans.freeT(function (v) {
        return Control_Applicative.pure(dictMonad.Applicative0())(Data_Either.Right.create(Data_Functor_Coproduct.left(Control_Applicative.pure(Control_Monad_Free_Trans.applicativeFreeT(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple))(dictMonad)))));
    });
};
var fromCoTransformer = function (dictMonadRec) {
    return function (t) {
        var go = function (v) {
            return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_Free_Trans.bindFreeT(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple))(dictMonadRec.Monad0()))(yieldT(dictMonadRec.Monad0())(v.value0))(function () {
                return Control_Bind.bind(Control_Monad_Free_Trans.bindFreeT(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple))(dictMonadRec.Monad0()))(awaitT(dictMonadRec.Monad0()))(function (mi) {
                    return Data_Maybe.maybe(Control_Applicative.pure(Control_Monad_Free_Trans.applicativeFreeT(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple))(dictMonadRec.Monad0()))(Data_Unit.unit))((function () {
                        var $98 = fromCoTransformer(dictMonadRec);
                        return function ($99) {
                            return $98(v.value1($99));
                        };
                    })())(mi);
                });
            });
        };
        return Control_Bind.bind(Control_Monad_Free_Trans.bindFreeT(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple))(dictMonadRec.Monad0()))(Control_Monad_Trans_Class.lift(Control_Monad_Free_Trans.monadTransFreeT(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple)))(dictMonadRec.Monad0())(Control_Monad_Free_Trans.resume(Control_Coroutine.functorCoTransform)(dictMonadRec)(t)))(function (a) {
            return Data_Either.either(Data_Function["const"](Control_Applicative.pure(Control_Monad_Free_Trans.applicativeFreeT(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple))(dictMonadRec.Monad0()))(Data_Unit.unit)))(go)(a);
        });
    };
};
var fromTransformer = function (dictMonadRec) {
    return function (t) {
        var go = function (v) {
            return Control_Bind.bind(Control_Monad_Free_Trans.bindFreeT(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple))(dictMonadRec.Monad0()))(awaitT(dictMonadRec.Monad0()))(function (mi) {
                if (mi instanceof Data_Maybe.Nothing) {
                    return Control_Applicative.pure(Control_Monad_Free_Trans.applicativeFreeT(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple))(dictMonadRec.Monad0()))(Data_Unit.unit);
                };
                if (mi instanceof Data_Maybe.Just) {
                    var v1 = v(mi.value0);
                    return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_Free_Trans.bindFreeT(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple))(dictMonadRec.Monad0()))(yieldT(dictMonadRec.Monad0())(v1.value0))(function () {
                        return fromTransformer(dictMonadRec)(v1.value1);
                    });
                };
                throw new Error("Failed pattern match at Control.Coroutine.Transducer (line 133, column 6 - line 138, column 27): " + [ mi.constructor.name ]);
            });
        };
        return Control_Bind.bind(Control_Monad_Free_Trans.bindFreeT(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple))(dictMonadRec.Monad0()))(Control_Monad_Trans_Class.lift(Control_Monad_Free_Trans.monadTransFreeT(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple)))(dictMonadRec.Monad0())(Control_Monad_Free_Trans.resume(Control_Coroutine.functorTransform)(dictMonadRec)(t)))(function (a) {
            return Data_Either.either(Data_Function["const"](Control_Applicative.pure(Control_Monad_Free_Trans.applicativeFreeT(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple))(dictMonadRec.Monad0()))(Data_Unit.unit)))(go)(a);
        });
    };
};
var liftStateful = function (dictMonad) {
    return function (f) {
        return function (eof) {
            return function (s) {
                return Control_Bind.bind(Control_Monad_Free_Trans.bindFreeT(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple))(dictMonad))(awaitT(dictMonad))(function (mi) {
                    return Data_Maybe.maybe(Data_Foldable.traverse_(Control_Monad_Free_Trans.applicativeFreeT(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple))(dictMonad))(Data_Foldable.foldableArray)(yieldT(dictMonad))(eof(s)))(function (i) {
                        var v = f(s)(i);
                        return Control_Bind.bind(Control_Monad_Free_Trans.bindFreeT(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple))(dictMonad))(Data_Foldable.traverse_(Control_Monad_Free_Trans.applicativeFreeT(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple))(dictMonad))(Data_Foldable.foldableArray)(yieldT(dictMonad))(v.value1))(function (v1) {
                            return liftStateful(dictMonad)(f)(eof)(v.value0);
                        });
                    })(mi);
                });
            };
        };
    };
};
var liftStateless = function (dictMonad) {
    return function (f) {
        return Control_Bind.bind(Control_Monad_Free_Trans.bindFreeT(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple))(dictMonad))(awaitT(dictMonad))(function (mi) {
            return Data_Maybe.maybe(Control_Applicative.pure(Control_Monad_Free_Trans.applicativeFreeT(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple))(dictMonad))(Data_Unit.unit))(function (i) {
                return Control_Bind.bind(Control_Monad_Free_Trans.bindFreeT(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple))(dictMonad))(Data_Foldable.traverse_(Control_Monad_Free_Trans.applicativeFreeT(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple))(dictMonad))(Data_Foldable.foldableArray)(yieldT(dictMonad))(f(i)))(function (v) {
                    return liftStateless(dictMonad)(f);
                });
            })(mi);
        });
    };
};
var transformM = function (dictMonad) {
    return function (f) {
        return Control_Bind.bind(Control_Monad_Free_Trans.bindFreeT(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple))(dictMonad))(awaitT(dictMonad))(function (mi) {
            return Data_Maybe.maybe(Control_Applicative.pure(Control_Monad_Free_Trans.applicativeFreeT(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple))(dictMonad))(Data_Unit.unit))(function (i) {
                return Control_Bind.bind(Control_Monad_Free_Trans.bindFreeT(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple))(dictMonad))(Control_Monad_Trans_Class.lift(Control_Monad_Free_Trans.monadTransFreeT(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple)))(dictMonad)(f(i)))(yieldT(dictMonad));
            })(mi);
        });
    };
};
var transform = function (dictMonad) {
    return function (f) {
        return transformM(dictMonad)((function () {
            var $100 = Control_Applicative.pure(dictMonad.Applicative0());
            return function ($101) {
                return $100(f($101));
            };
        })());
    };
};
var awaitForever = function (dictMonad) {
    return function (send) {
        return Control_Coroutine.loop(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple))(dictMonad)(Control_Bind.bind(Control_Monad_Free_Trans.bindFreeT(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple))(dictMonad))(awaitT(dictMonad))(function (mi) {
            if (mi instanceof Data_Maybe.Nothing) {
                return Control_Applicative.pure(Control_Monad_Free_Trans.applicativeFreeT(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple))(dictMonad))(new Data_Maybe.Just(Data_Unit.unit));
            };
            if (mi instanceof Data_Maybe.Just) {
                return Data_Functor.voidLeft(Control_Monad_Free_Trans.functorFreeT(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple))(((dictMonad.Bind1()).Apply0()).Functor0()))(send(mi.value0))(Data_Maybe.Nothing.value);
            };
            throw new Error("Failed pattern match at Control.Coroutine.Transducer (line 72, column 3 - line 74, column 32): " + [ mi.constructor.name ]);
        }));
    };
};
module.exports = {
    fuse: fuse,
    awaitT: awaitT,
    awaitForever: awaitForever,
    yieldT: yieldT,
    transform: transform,
    transformM: transformM,
    liftStateless: liftStateless,
    liftStateful: liftStateful,
    fromProducer: fromProducer,
    toProducer: toProducer,
    fromConsumer: fromConsumer,
    toConsumer: toConsumer,
    fromTransformer: fromTransformer,
    fromCoTransformer: fromCoTransformer,
    toProcess: toProcess
};
